import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
  ViewChild,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges,
  Inject,
  InjectionToken,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject, combineLatest, Observable, of, Subject } from 'rxjs';
import {
  Collection,
  Filter,
  FilterValue,
  LoadFilterdProductsByQuery,
  LoadProductsByQuery,
  LoadProductsFiltered,
  Pagination,
  Product,
  Variant,
} from '../../../shop';
import * as fromShopify from '../../../shop';
import { trigger } from '@angular/animations';
// import { CardGridAnimation } from '../../../animations';
import { CloseFilters, Go, OpenFilters, SetTags, SetTitle } from '../../../store';
import { ActivatedRoute, Router } from '@angular/router';
import { map, switchMap, takeUntil, withLatestFrom, tap, mergeMap, take, pairwise, filter, startWith } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { Breadcrumb } from 'src/app/core/models/breadcrumb.model';
import { ProductsService } from 'src/app/shop/services';
import { ProductFiltersComponent } from '../../components/product-filters/product-filters.component';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { ShopifyMetaFieldsPipe } from 'src/app/shop/pipes/shopify-metafields.pipe';
import { CookiePreferences, getCookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { isPlatformBrowser } from '@angular/common';
import { Analyzify } from 'src/app/utility/analyzify.utility';

@Component({
    selector: 'app-search-results',
    templateUrl: './search-results.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SearchResultsComponent implements OnInit, OnDestroy {
  private store = inject(Store);
  private dict = new FromDictionaryPipe(this.lang);
  private meta = new ShopifyMetaFieldsPipe();

  cookiePrefs$ = this.store.select(getCookiePreferences);
  searchResults$ = this.store.select(fromShopify.getSearchResults);
  q$ = this.store.select(fromShopify.getSearchQuery);
  page$ = this.store.select(fromShopify.getSearchPageInfo);
  loading$ = this.store.select(fromShopify.getSearchLoading);

  searchQuery?: string;

  products: any = [];

  page: Pagination = {
    current: 0,
    size: 1,
    pageCount: 5,
    resultCount: 5,
  };

  // Structured data
  scheme: any;
  breadcrumbScheme: any;
  breadcrumbs: Breadcrumb[] = [
    {
      label: 'zoekresultaten',
      routerLink: [],
    },
  ];

  private _unsubscribe = new Subject<void>();

  constructor(private router: Router, public route: ActivatedRoute, private lang: LanguageService) {}

  ngOnInit(): void {
    this.route.queryParams.pipe(takeUntil(this._unsubscribe), withLatestFrom(this.q$)).subscribe(([params, previousQuery]) => {
      if (params['q'] !== previousQuery) {
        //console.log('prev', previousQuery, 'new query', params['q']);
        this.searchQuery = params['q'];
        this.store.dispatch(fromShopify.LoadSearchResults({ searchQuery: params['q'] }));
      }
    });

    this.searchResults$.pipe(takeUntil(this._unsubscribe)).subscribe(products => {
      this.setScheme(products);
    });
  }

  loadMore() {
    this.store.dispatch(fromShopify.LoadMoreSearchResults());
  }

  setMeta(q: string) {
    // Set metadata
    this.store.dispatch(SetTitle({ title: this.dict.transform('zoek-overzicht-titel') }));
    this.store.dispatch(
      SetTags({
        properties: {
          'description': this.dict.transform('zoek-overzicht-beschrijving') + q ? ` ${q}` : '',
          'og:image': '',
          'og:title': `${this.dict.transform('zoek-overzicht-titel')} - ${this.dict.transform('meta-titel-suffix')}`,
          'og:description': this.dict.transform('zoek-overzicht-beschrijving') + q ? ` ${q}` : '',
        },
      })
    );
  }

  trackByFn(index: number, item: Product) {
    return item?.id;
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }

  setScheme(products: Product[]) {
    this.scheme = {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      'name': 'Alle producten',
      'url': this.router.url,
      'description': 'Alle producten',
      'image': 'https://cdn.shopify.com/s/files/1/0622/3881/8561/collections/placeholder.png',
      'mainEntityOfPage': {
        '@type': 'CollectionPage',
        '@id': environment.storeDomain + this.router.url,
      },
      'itemListElement': products.map((product, i) => ({
        '@type': 'ListItem',
        'position': i + 1,
        'url': environment.storeDomain + '/products' + product?.handle,
      })),
    };
  }

  setBreadcrumbScheme() {
    this.breadcrumbScheme = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': [
        {
          '@type': 'ListItem',
          'position': 1,
          'item': {
            '@type': 'Website',
            '@id': environment.storeDomain,
            'name': environment.storeName,
          },
        },
        {
          '@type': 'ListItem',
          'position': 2,
          'item': {
            '@type': 'CollectionPage',
            '@id': environment.storeDomain + this.router.url,
            'name': 'Alle producten',
          },
        },
      ],
    };
  }

  getLength(a: any) {
    return Object.keys(a);
  }
}
